// constants
import { REIMBURSMENT_DECL_VERIFICATION } from "constants/global";

// Type Definitions
import type { ReimbursementResponseType, UserPermissionType } from "redux/types";

export function formatReimbVerificationData(reimbVoucherGroupAccess: UserPermissionType[]) {
	const reimbVoucherGroupAccessList = reimbVoucherGroupAccess?.map((_group) => {
		return {
			voucher_group_code: _group?.perm_val3,
			voucher_group_desc: _group?.perm_short_desc
		};
	});
	return reimbVoucherGroupAccessList;
}

export function getReimbVerificationRecordCount(reimbVoucherGroupAccess: UserPermissionType[], reimbSummaryList: ReimbursementResponseType) {
	let updatedRecordCount = 0;

	if (reimbSummaryList) {
		reimbVoucherGroupAccess?.forEach(({ perm_val3 }) => {
			updatedRecordCount += Number(reimbSummaryList?.groupCodeCount[perm_val3]);
		});
	}

	return updatedRecordCount;
}

export function getAllVoucherTypes(configDetailsData: any[]) {
	return configDetailsData?.reduce((acc, config) => {
		if (config?.config_mst_code === REIMBURSMENT_DECL_VERIFICATION.CONFIG_MASTER_CODE_VOUCHER_TYPES) {
			acc.push({
				voucher_group_code: Number(config?.config_dtl_code),
				voucher_group_desc: config?.config_dtl_desc
			});
		}
		return acc;
	}, []);
}
